<template>
    <div class="organization">
        <div class="main">
            <van-form @submit="onSubmit" input-align="left">
                <div class="card">
                    <div class="card_item">
                        <van-field
                            v-model="organization.name"
                            name="name"
                            label="机构名称"
                            required
                            :rules="organizationRules.name"
                            />
                    </div>
                    <div class="card_item">
                        <van-field
                            v-model="organization.region"
                            name="region"
                            label="所在地区"
                            placeholder="请选择"
                            required
                            clickable
                            readonly
                            right-icon="arrow"
                            :rules="organizationRules.region"
                            @click="showRegionIdPicker = true"
                        />
                    </div>
                    <div class="card_item">
                        <van-field
                            v-model="organization.contacter"
                            name="contacter"
                            label="联系人"
                            required
                            :rules="organizationRules.contacter"
                        />
                    </div>
                    <div class="card_item">
                        <van-field
                            v-model="organization.phone"
                            type="tel"
                            name="phone"
                            label="联系电话"
                            required
                            maxlength="11"
                            :rules="organizationRules.phone"
                        />
                        <span :class="['code-btn',{'gray': send}]" @click="sendCode">{{sendText}}</span>
                    </div>
                    <div class="card_item">
                        <van-field
                            v-model="organization.code"
                            name="code"
                            label="输入验证码"
                            required
                            maxlength="6"
                            :rules="organizationRules.code"
                        />
                    </div>
                </div>

                <div class="submit">
                    <van-button block color="#00CBCC" type="primary" 
                        native-type="submit">
                        下一步
                    </van-button>
                </div>
            </van-form>
        </div>

        <!-- 机构所在地区 -->
        <van-popup v-model="showRegionIdPicker" position="bottom">
            <van-picker
                title="机构所在地区"
                show-toolbar
                value-key="name"
                :columns="regionList"
                @confirm="regionConfirm"
                @cancel="showRegionIdPicker = false"
            />
        </van-popup>

        <!-- 生成的二维码地址 -->
        <van-popup v-model="popupShow" round>
            <div class="popup_main">
                <img class="close_icon" src="@/assets/olympicMusicShow/delete.png" @click="closePopupShow">       
                <div class="qrBox">
                    <div ref="qrcode" id="qrcode" style="display:none"></div>
                    <div ref="qrcodeImg"></div>
                </div> 
                <div class="title">赛事报名渠道申请</div>
                <div class="text">长按保存二维码</div>      
            </div>
        </van-popup>
    </div>
</template>

<script>
import { Form, Field, Popup, Picker, Button, Toast } from 'vant'
import { ApiQueryregions, ApiApplycompetitionchannel } from '@/api/olympicMusicShow.js'
import { validMobile } from '@/utils/validate.js'
import { deepClone } from '@/utils/'
import { ApiSendCode } from '@/api/login.js'
import QRCode from "qrcodejs2";


export default {
    name: 'organization',
    components: {
        vanForm: Form,
        vanField: Field,
        vanPopup: Popup,
        vanPicker: Picker,
        vanButton: Button,
    },
    data() {
        return {
            organization: {
                name:null,
                region: null,
                regionId: null,
                contacter: null,
                phone: null,
                code: null
            },
            organizationRules: {
                name: [{ required: true, message: '请填写机构名称' }],
                region: [{ required: true, message: '请选择机构所在地区' }],
                contacter: [{ required: true, message: '请填写机构联系人' }],
                phone: [
                    { required: true, message: '请填写联系电话' },
                    { validator: validMobile,  message: '手机号格式不正确'}
                ],
                code: [{ required: true, message: '请输入验证码' }],
            },
            regionIdIndex: [],
            showRegionIdPicker: false,
            regionList: [],
            send: false,
            sendText: '获取验证码',
            timer: "",
            count: 60,
            popupShow: false,
            competitionId: null
        }  
    },
    mounted(){
        this.competitionId = this.$route.query.id
        console.log(this.$route.query.id,'this.competitionId')
        this.getQueryregions()
    },
    methods: {
        getQueryregions() {
            ApiQueryregions({parentId: 0}).then(res => {
                if (res.code === 200) {
                    this.regionList = res.data.map(ele1 => {
                        ele1.children = ele1.childs
                        delete ele1.childs
                        ele1.children = ele1.children.map(ele2 => {
                            ele2.children = ele2.childs
                            delete ele2.childs

                            ele2.children = ele2.children.map(ele3 => {
                                delete ele3.childs
                                return ele3
                            })

                            return ele2
                        })

                        return ele1
                    })
                } else {
                    this.regionList = []
                }
            })
        },

        regionConfirm(value, index) {
            this.organization.region = value.join('/')
            this.regionIdIndex = index
            this.showRegionIdPicker = false
            this.organization.regionId = this.regionList[this.regionIdIndex[0]].children[this.regionIdIndex[1]].children[this.regionIdIndex[2]].id
        },
        sendCode(){
            let telReg = validMobile(this.organization.phone)
            if(!telReg){
                Toast('请输入正确的手机格式')
                return
            }
            if (this.send) { return }
            this.send = true
            ApiSendCode({phone: this.organization.phone}).then(res=>{
                if(res.code == 200){
                    Toast(res.msg)
                    this.timer = setInterval(()=>{
                        if (this.count >= 1) {
                            this.count--;
                            this.sendText = this.count + "S";
                        } else {
                            this.count = 60;
                            this.sendText = "获取验证码";
                            this.send = false;
                            clearInterval(this.timer)
                        }
                    },1000)
                } else {
                    Toast(res.msg)
                    this.send = false;
                    clearInterval(this.timer)
                }
            })
        },
        onSubmit(){
            let params = deepClone(this.organization)
            params.competitionId = this.competitionId

            ApiApplycompetitionchannel({channel: params}).then(res=>{
                if(res.code == 200){
                    this.popupShow = true
                    setTimeout(()=>{
                        this.creatQRCode(res.data)
                    },100)
                } else {
                    Toast(res.msg)
                }
            })
            
        },
        creatQRCode(data){
            let qrcode = new QRCode(this.$refs.qrcode, {
                text: data,
                colorDark: "#00CBCC",
                colorLight: "#fff",
                width: 100,
                height: 100,
            });
            let canvas = document.getElementsByTagName('canvas')[0]
            let img = this.convertCanvasToImage(canvas)
            this.$refs.qrcodeImg.append(img)
        },
        convertCanvasToImage(canvas) {
            let image = new Image()
            image.src = canvas.toDataURL("image/png")
            return image
        },
        closePopupShow(){
            this.popupShow = false
            const qrcodeHtml = document.getElementById('qrcode')
            qrcodeHtml.innerHTML = ''
            this.$refs.qrcode.innerHTML = ''
            this.$refs.qrcodeImg.innerHTML = ''
        }
    }
}
</script>

<style lang="scss">
@import '../../assets/css/flexable.scss';
.organization {
    .van-cell {
        padding: 0;
        padding-left: 16px;
    }
    .van-cell__title {
        font-size: px2rem(32);
        font-weight: 500;
        color: #1F1F1F;
    }
    .van-cell::after {
        border: none;
    }
    width: 100vw;
    min-height: 100vh;
    background-color: #F5F5F9;
    .main {
        padding-top: px2rem(30);
        .card {
            margin-bottom: 3.73vw;
            width: 100%;
            padding: 0 3.73vw 0 4.27vw;
            background-color: #fff;
            box-sizing: border-box;
            &:last-child {
                margin-bottom: 0;
            }
            .card_item {
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;
                padding: 4.27vw 0;
                border-bottom: 1px solid #F3F4F6;
                
                &:last-child {
                    border-bottom: 0;
                }
                .code-btn {
                    width: 100px;
                }
                .gray {color: #969799}
            }
        }
    }
    .submit {
      width: 100%;
      padding: 40px 20px 44px 20px;
      box-sizing: border-box;
    }
    .popup_main {
        position: relative;
        width: px2rem(600);
        height: px2rem(400);
        padding-top: px2rem(80);
        .close_icon {
            position: absolute;
            top: px2rem(26);
            right: px2rem(26);
            z-index: 1;
            width: px2rem(52);
            height: px2rem(52);
        }
        .title {
            margin: px2rem(22) 0;
            text-align: center;
            font-size: px2rem(36);
            font-weight: bold;
            color: #1F1F1F;
            line-height: 1;
        }
        .text {
            text-align: center;
            font-size: px2rem(32);
            font-weight: 500;
            color: #585858;
            line-height: 1;
        }
    }
}
</style>
